// src/components/listing/ListingRow.js
// Rangée horizontale d'annonces par catégorie (style Airbnb) - NE PAS MODIFIER

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../hooks/useTheme';
import ListingRowCard from './ListingRowCard';
import { preloadImages } from '../../utils/preloadImages';
import { getImageUrl } from '../../utils/imageUrl';

const ListingRow = ({ icon, title, description, listings = [], seeAllRoute }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { theme } = useTheme();

  // Précharge les images des annonces de cette rangée dès qu'elle apparaît
  useEffect(() => {
    if (!listings || listings.length === 0) return;
    const urls = listings
      .map((l) => l.images?.[0])
      .filter(Boolean)
      .map((path) => getImageUrl(path));
    preloadImages(urls);
  }, [listings]);

  // Ne pas afficher la rangée si aucune annonce
  if (!listings || listings.length === 0) return null;

  const styles = {
    section: {
      marginBottom: '24px',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      padding: '0 16px',
      marginBottom: '12px',
    },
    titleGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
    },
    title: {
      fontSize: '18px',
      fontWeight: '700',
      color: theme.textPrimary,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    description: {
      fontSize: '13px',
      color: theme.textSecondary,
    },
    seeAll: {
      fontSize: '13px',
      fontWeight: '600',
      color: theme.gold,
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      background: 'none',
      border: 'none',
      padding: 0,
    },
    scrollContainer: {
      display: 'flex',
      gap: '12px',
      overflowX: 'auto',
      padding: '4px 16px 8px',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    },
  };

  return (
    <div style={styles.section}>
      <div style={styles.header}>
        <div style={styles.titleGroup}>
          <div style={styles.title}>
            <span>{icon}</span>
            {title}
          </div>
          {description && <div style={styles.description}>{description}</div>}
        </div>
        {seeAllRoute && (
          <button style={styles.seeAll} onClick={() => navigate(seeAllRoute)}>
            {t('sections.seeAll')} →
          </button>
        )}
      </div>

      <div style={styles.scrollContainer} className="hide-scrollbar">
        <style>{`
          .hide-scrollbar::-webkit-scrollbar { display: none; }
        `}</style>
        {listings.map((listing) => (
          <ListingRowCard key={listing.id} listing={listing} />
        ))}
      </div>
    </div>
  );
};

export default ListingRow;